import { createContext, useContext, useMemo } from 'react';

const CarouselContext = createContext(null);

/**
 * Currently used by v1 & v2 Carousels.
 *
 * Useful for accessing the emblaApi from within a Carousel's product card to support
 * tracking carousel metadata like slide index.
 *
 * @returns {Object} - The emblaApi and any other props passed to the CarouselProvider.
 */
function CarouselProvider({ children, ...restProps }) {
    const contextValue = useMemo(() => restProps, [restProps]);

    return <CarouselContext.Provider value={contextValue}>{children}</CarouselContext.Provider>;
}

export function useCarouselContext() {
    const context = useContext(CarouselContext);
    return context || {};
}

export default CarouselProvider;
